
export class LongOperation {
	/**
	 *
	 * @param {string} id - ID of server LongOperation instance
	 * @param {number} checkFreq - frequency in milliseconds how often contact server to check operation state
	 */
	constructor(id, checkFreq = 1000) {
		this.id = id;
		this.freq = checkFreq;
		this.timer = 0;
		this.progressHandlers = [];
		this.errorHandlers = [];
		this.doneHandlers = [];
		this.cancelHandlers = [];
	}

	/**
	 * Listen to an event
	 * @param {string} eventName - one of supported event names (progress|error|done|cancel)
	 * @param {function} handler - event handler
	 */
	on(eventName, handler) {
		let handlers;
		switch (eventName) {
			case "progress":
				handlers = this.progressHandlers;
				break;
			case "error":
				handlers = this.errorHandlers;
				break;
			case "done":
				handlers = this.doneHandlers;
				break;
			case "cancel":
				handlers = this.cancelHandlers;
				break;
		}
		handlers.push(handler);
		return this;
	}

	static fire(handlers, data) {
		handlers.forEach(h => h(data));
	}

	/**
	 * Start checking long operation state
	 */
	start() {
		if (this.timer === 0) this.timer = window.setInterval(this.pollServer.bind(this), this.freq);
	}

	/**
	 * Stop checking long operation state (but the operation can still run on the server)
	 */
	stop() {
		if (this.timer !== 0) {
			window.clearInterval(this.timer);
			this.timer = 0;
			return true;
		} else return false;
	}

	/**
	 * Stop checking long operation state and cancel operation on the server also
	 */
	cancel() {
		const that = this;
		if (this.stop()) {
			$.get("longOperation.do?id=" + this.id + "&op=cancel")
				.done(function (data) {
					LongOperation.fire(that.cancelHandlers, data);
				}).fail(function (data) {
				LongOperation.fire(that.errorHandlers, data);
			});
		} else {
			LongOperation.fire(that.cancelHandlers, null);
		}
	}

	pollServer() {
		const that = this;
		$.get("longOperation.do?id="+this.id)
			.done(function(data) {
				if ("work" !== data.state) {
					that.stop();
				}
				switch (data.state) {
					case "cancel":
						LongOperation.fire(that.cancelHandlers, data);
						break;
					case "done":
						LongOperation.fire(that.progressHandlers, data);
						LongOperation.fire(that.doneHandlers, data.result);
						break;
					case "fail":
						LongOperation.fire(that.errorHandlers, data.exception);
						break;
					case "work":
						LongOperation.fire(that.progressHandlers, data);
						break;
				}
			}).fail(function(data) {
				that.stop();
			console.log(JSON.stringify(data));
				LongOperation.fire(that.errorHandlers, data);
			});
	}
}
